<template>
  <v-card flat style="box-shadow: none" v-if="creditCard">
    <div class="credit-card-wrapper">
      <div class="credit-card-from">
        <v-text-field
          id="v-card-number"
          ref="number"
          data-card-field
          autocomplete="off"
          :maxlength="cardNumberMaxLength"
          @input="changeNumber"
          name="number"
          outlined
          dense
          v-mask="creditCardMask"
          label="Número do Cartão"
          v-validate="'required'"
          :disabled="disabled"
          :v-errors="errors"
          :error-messages="errors.collect('number')"
          data-vv-name="Número do Cartão"
          v-model="creditCard.cardNumber"
          @blur="$emit('onCardNumberBlur')"
        >
        </v-text-field>
        <v-text-field
          id="v-card-name"
          name="name"
          label="Nome (igual ao cartão)"
          outlined
          dense
          data-card-field
          v-validate="'required'"
          :disabled="disabled"
          @input="changeName"
          :v-errors="errors"
          :error-messages="errors.collect('name')"
          data-vv-name="Nome"
          v-model="creditCard.cardName"
        >
        </v-text-field>
        <div class="fields-row">
          <v-select
            aria-label="Card Month"
            title="Month"
            v-model="creditCard.cardMonth"
            data-card-field
            :items="[
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10',
              '11',
              '12',
            ]"
            id="v-card-month"
            label="Mês"
            outlined
            dense
            masked="true"
            :disabled="disabled"
            v-validate="'required'"
            @input="changeMonth"
            :v-errors="errors"
            :error-messages="errors.collect('expiry')"
            data-vv-name="Validade"
          >
          </v-select>
          <v-select
            id="v-card-year"
            v-model="creditCard.cardYear"
            name="expiryYear"
            label="Ano"
            :items="this.cardYears"
            outlined
            dense
            data-card-field
            :disabled="disabled"
            v-validate="'required'"
            @input="checkCard()"
            :v-errors="errors"
            :error-messages="errors.collect('expiry')"
            data-vv-name="Validade"
          >
          </v-select>
          <v-text-field
            name="v-card-cvv"
            label="CVV"
            v-model="creditCard.cardCvv"
            outlined
            dense
            v-mask="'####'"
            :disabled="disabled"
            :id="this.cardInputFields.cardCvv"
            maxlength="4"
            data-card-field
            autocomplete="off"
            @input="changeCvv()"
            v-validate="'required|min:3'"
            :v-errors="errors"
            :error-messages="errors.collect('cvv')"
            data-vv-name="cvv"
          >
          </v-text-field>
        </div>
        <v-select
          v-if="!showEndButton"
          :items="creditCard.installments"
          item-text="text"
          item-value="id"
          label="Parcelamento"
          @focus="checkCard()"
          selected
          outlined
          dense
          v-validate="'required'"
          :v-errors="errors"
          :error-messages="errors.collect('parcelas')"
          data-vv-name="parcelas"
          :disabled="this.disabled"
          v-model="creditCard.selectedInstallment"
          @input="$emit('onInstallmentChange')"
        ></v-select>
        <v-btn
          v-if="showEndButton"
          :loading="disabled"
          :disabled="
            !creditCard.cardNumber ||
            !creditCard.cardName ||
            !creditCard.cardMonth ||
            !creditCard.cardYear ||
            !creditCard.cardCvv ||
            disabled
          "
          color="primary"
          rounded
          style="max-width: 120px"
          @click="$emit('end', creditCard)"
        >
          Confirmar
        </v-btn>
      </div>
      <vue-paycard
        ref="c"
        :is-card-number-masked="false"
        :value-fields="creditCard"
        :input-fields="this.cardInputFields"
        :labels="this.cardLabels"
        :background-image="this.cardImage"
        v-if="$vuetify.breakpoint.mdAndUp"
      />
    </div>
    <div v-if="advice" class="mt-3">
      {{ advice }}
    </div>
  </v-card>
</template>

<style>
.card-item__side {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 0px 0px 0px rgb(14 42 90 / 55%) !important;
  transform: perspective(2000px) rotateY(0) rotateX(0) rotate(0);
  transform-style: preserve-3d;
  transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 100%;
}
</style>
<style scoped>
.row-fix {
  margin-left: 0;
  margin-right: 0;
}

.row-fix .row {
  margin-left: 0;
  margin-right: 0;
}
</style>

<script>
import { mask } from "vue-the-mask";
import { VuePaycard } from "vue-paycard";

const defaultProps = {
  cardName: "",
  cardNumber: "",
  cardMonth: "",
  cardYear: "",
  cardCvv: "",
};

export default {
  directives: { mask },
  components: { VuePaycard },
  props: {
    showEndButton: {
      type: Boolean,
      default: false,
    },
    advice: {
      type: String,
      default: "",
    },
    creditCard: {
      required: true,
      default: defaultProps,
    },
    selectedInstallment: {
      required: false,
    },
    isValid: {
      default: false,
      type: Boolean,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      creditCardMask: "#### #### #### ####",
      minCardYear: new Date().getFullYear(),
      mainCardNumber: "",
      cardYears: [],
      cardNumberMaxLength: 19,
      cardInputFields: {
        cardNumber: "v-card-number",
        cardName: "v-card-name",
        cardMonth: "v-card-month",
        cardYear: "v-card-year",
        cardCvv: "v-card-cvv",
      },
      cardLabels: {
        cardName: "Nome Completo",
        cardHolder: "Nome no Cartão",
        cardMonth: "MM",
        cardYear: "AA",
        cardExpires: "Validade",
        cardCvv: "CVV",
      },
      cardImage: null,
    };
  },
  watch: {
    cardYear() {
      if (this.creditCard.cardMonth < this.minCardMonth) {
        this.creditCard.cardMonth = "";
      }
    },
  },
  created() {
    this.initCheckout();
  },
  methods: {
    initCheckout() {
      this.creditCard = defaultProps;
      this.loadSelects();
      this.setRandomCardImage();
    },
    setRandomCardImage() {
      const isSharkImage = Math.round(Math.random() * 1);
      if (isSharkImage) {
        const imgNumber = Math.round(Math.random() * (4 - 1) + 1);
        this.cardImage = `/img/checkout/cards/${imgNumber}.jpg`;
      } else {
        this.cardImage = null;
      }
      console.log("card image", this.cardImage);
    },
    loadSelects() {
      this.cardYears = [];
      for (let i = this.minCardYear; i <= this.minCardYear + 12; i++) {
        this.cardYears.push(i);
      }
    },
    changeName(e) {
      // console.log(e)
      this.creditCard.cardName = e;
      this.$emit("input-card-name", this.creditCard.cardName);
      this.checkCard();
    },
    changeNumber(e) {
      this.creditCard.cardNumber = e;
      const value = this.creditCard.cardNumber.replace(/\D/g, "");
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(value)) {
        this.creditCard.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 18;
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
        // diner's club, 14 digits
        this.creditCard.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 16;
      } else if (/^62[0-9]\d*/.test(value)) {
        this.creditCard.cardNumber = value
          .replace(/(\d{6})/, "$1 ")
          .replace(/(\d{6}) (\d{7})/, "$1 $2 ")
          .replace(/(\d{6}) (\d{7}) (\d{6})/, "$1 $2 $3 ")
          .replace(/(\d{5}) (\d{5}) (\d{5}) (\d{4})/, "$1 $2 $3 $4");
        this.cardNumberMaxLength = 21;
      } else if (/^\d{0,16}$/.test(value)) {
        // regular cc number, 16 digits
        this.creditCard.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
          .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
        this.cardNumberMaxLength = 19;
      }

      if (e.inputType === "deleteContentBackward") {
        const lastChar = this.creditCard.cardNumber.substring(
          this.creditCard.cardNumber.length,
          this.creditCard.cardNumber.length - 1,
        );
        if (lastChar === " ") {
          this.creditCard.cardNumber = this.creditCard.cardNumber.substring(
            0,
            this.creditCard.cardNumber.length - 1,
          );
        }
      }
      this.$emit("input-card-number", this.creditCard.cardNumber);
      this.checkCard();
    },
    changeMonth() {
      this.$emit("input-card-month", this.creditCard.cardMonth);
      this.checkCard();
    },
    changeYear() {
      this.$emit("input-card-year", this.creditCard.cardYear);
      this.checkCard();
    },
    changeCvv(e) {
      console.log("cvv", e);
      // this.creditCard.cardCvv = e
      this.$emit("input-card-cvv", this.creditCard.cardCvv);
      this.checkCard();
    },
    checkCard() {
      console.log("checking.. ");
      this.formHasErrors().then(() => {
        let ready = false;
        if (
          this.creditCard.cardName.length > 5 &&
          this.creditCard.cardMonth.length === 2 &&
          this.creditCard.cardYear >= this.minCardYear &&
          this.creditCard.cardNumber.length <= this.cardNumberMaxLength &&
          this.creditCard.cardCvv.length >= 3 &&
          this.errors.items.length === 0
        ) {
          ready = true;
          // console.log('valido')
        }
        // console.log('ready: ', ready)
        this.$emit("isCardValid", ready);
      });
      if (
        this.creditCard.cardName.length > 5 &&
        this.creditCard.cardMonth.length === 2 &&
        this.creditCard.cardYear >= this.minCardYear &&
        this.creditCard.cardNumber.length <= this.cardNumberMaxLength &&
        this.creditCard.cardCvv.length >= 3
      ) {
        this.$emit("isCardValid", true);
      }
    },
    hasInstallments() {
      let ret = false;
      // console.log('credit card', this.creditCard)
      if (this.creditCard === undefined) {
        ret = true;
      }
      if (this.creditCard.installments.length === 0) {
        ret = true;
      }
      return ret;
    },
  },
  computed: {
    minCardMonth() {
      if (this.creditCard.cardYear === this.minCardYear)
        return new Date().getMonth() + 1;
      return 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-card-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
}
.credit-card-from {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 5px;
  width: 100%;
  .fields-row {
    display: flex;
    flex-wrap: nowrap;
    column-gap: 10px;
  }
}
</style>
